import API from 'utils/api';
import { onSuccess, onError } from 'utils/handlers';
import getFormattedValues, { formatReceived } from 'utils/formatValues';
import Moment from 'moment';

export const baseURI = '/empresas/direcciones-verificadas-de-contribuyentes/';
const BASE_URI_INSPECTORES = '/usuarios/usuario-inspector/';

/**
 * GET Verificados
 * @param {Object} params
 * @returns {Promise<Array<object>>}
 */
export const getVerificados = async (params = null) => {
  try {
    const response = await API.get(baseURI, { params });
    const output = { ...response.data, results: formatReceived(response.data.results) };
    return output;
  } catch (err) {
    onError(err);
    return { results: [] };
  }
};
/**
 * GET Verificado
 * @param {number} id
 * @returns {Promise<object>}
 */
export const getVerificado = async (id) => {
  try {
    const response = await API.get(`${baseURI}${id}`);
    return formatReceived(response.data);
  } catch (err) {
    onError(err);
    return null;
  }
};

/**
 * POST ZonaExlusiva
  * @param {object} values
 * @returns {Promise<object|boolean>}
 */
export const postVerificado = async (values) => {
  try {
    const valuesEntidad = values;
    valuesEntidad.entidad = 1;
    const response = await API.post(baseURI, getFormattedValues(values));
    onSuccess(response, 'Agregado correctamente');
    return formatReceived(response.data);
  } catch (err) {
    onError(err);
    return false;
  }
};

/**
 * PATCH Verificado
 * @param {number} id
 * @param {object} _values
 * @returns {Promise<object|boolean>}
 */
export const patchVerificado = async (id, _values) => {
  try {
    const values = {
      ..._values,
      fecha_de_ultimo_movimiento: Moment(),
    };
    const response = await API.patch(`${baseURI}${id}`, getFormattedValues(values));
    onSuccess(response, 'Editado correctamente');
    return formatReceived(response.data);
  } catch (err) {
    onError(err);
    return false;
  }
};
/**
 * DELETE Verificado
 * @param {number} id
 * @returns {Promise<object|boolean>}
 */
export const deleteVerificado = async (id) => {
  try {
    const response = await API.delete(`${baseURI}${id}/`);
    onSuccess(response, 'Eliminado correctamente');
    return true;
  } catch (err) {
    onError(err);
    return false;
  }
};

/**
 * GET Zonas Exclusivas para la caja
 * @param {object} params
 * @returns {Promise<Array<Object>>}
 */
export const getZonasExclusivasCaja = async (params = null) => {
  try {
    const response = await API.get('/empresas/zonas-exclusivas-caja/', { params });
    return response.data;
  } catch (err) {
    onError(err);
    return [];
  }
};

/**
 * GET usuarios inspectores
 * @param {object} params
 * @returns {Promise<Array<Object>>}
 */
export const getUsuariosInspectores = async (params = null) => {
  try {
    const response = await API.get(BASE_URI_INSPECTORES, { params });
    return response.data;
  } catch (err) {
    onError(err);
    return [];
  }
};

/**
 * GET usuario inspector
 * @param {number} id
 * @returns {Promise<Object>}
 */
export const getUsuarioInspector = async (id) => {
  try {
    const response = await API.get(`${BASE_URI_INSPECTORES}${id}`);
    return response.data;
  } catch (err) {
    onError(err);
    return {};
  }
};

/**
 * GET archivo de verificado
 * @param {object} id
 * @returns {Promise<Object|boolean>}
 */

export const getArchivoVerificado = async (id) => {
  try {
    const response = await API.get(`/empresas/archivos-de-direcciones-verificadas/${id}`);
    return response.data;
  } catch (err) {
    onError(err);
    return false;
  }
};
